import { useId } from "react";

import { useUpdateNotificationSettingMutation } from "../api/useUpdateNotificationSettingMutation";
import type { NotificationSettingEntry, NotificationSettingText } from "../types";

import { Label } from "@/components/ui/v2/label";
import { Switch } from "@/components/ui/v2/switch";

type NotificationSettingRowProps = {
  entry: NotificationSettingEntry;
  text: NotificationSettingText;
};

export function NotificationSettingRow({ entry, text }: NotificationSettingRowProps) {
  const switchId = useId();
  const descriptionId = useId();
  const { mutate } = useUpdateNotificationSettingMutation(entry, text.label);

  return (
    <li className="flex items-center justify-between gap-6 px-4 py-4">
      <div className="flex min-w-0 max-w-[65ch] flex-col gap-1 wrap-anywhere">
        <Label htmlFor={switchId} className="cursor-pointer leading-snug">
          {text.label}
        </Label>
        <p id={descriptionId} className="text-sm text-muted-foreground">
          {text.description}
        </p>
      </div>
      <Switch id={switchId} checked={entry.enabled} onCheckedChange={mutate} aria-describedby={descriptionId} />
    </li>
  );
}
